import { translate } from '../../utils/translate/translations';

export default function normalizePackages(packages) {
  return packages.map((pkg) => {
    return {
      ...pkg,
      id: pkg.label,
      options: pkg.options.map((option) => {
        return {
          ...option,
          optionMarker: pkg.key === 'more.packages' ? '' : pkg.label,
        };
      }),
    };
  });
}

export function nomrmalizeConflictPackageOptions(userChoiceOptions) {
  return userChoiceOptions.map((option) => {
    if (option?.hierarchy?.step === 'packages') {
      return {
        ...option,
        optionMarker: translate(`package.marker.${option.hierarchy.category}`),
      };
    }
    return option;
  });
}
